import { useState, useReducer } from 'react';

import { useDeepCompareEffect } from '../utils';

export const initialState = {
  data: [],
  initial: true,
  fetching: false,
  fetched: false,
  error: null,
  pagination: { page: null, count: null, total: null },
  sorting: { sort: null, desc: false },
};

export function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'FETCHING':
      return { ...state, initial: false, fetching: true };
    case 'REFRESH_TABLE':
      return { ...state, data: state.data.filter(({ id }) => id !== payload) };
    case 'SUCCESS': {
      const { count, total, page, desc, sort } = payload;

      return {
        ...state,
        fetching: false,
        fetched: true,
        data: payload.data,
        pagination: { ...state.pagination, count, total, page },
        sorting: { ...state.sorting, desc, sort },
      };
    }
    case 'FAILURE':
      return {
        ...state,
        fetched: true,
        error: payload.message,
      };
    default:
      return state;
  }
}

export default function usePagination({ request, params = {}, selector }) {
  const [options, setOptions] = useState({
    page: 0,
    count: 12,
    desc: false,
    ...params,
  });
  const { page, count, sort, desc } = options;

  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    pagination: {
      ...initialState.pagination,
      page,
      count,
    },
    sorting: {
      ...initialState.sorting,
      sort,
      desc,
    },
  });

  useDeepCompareEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCHING' });

      try {
        const { data } = await request({ ...options });
        const handledData = selector ? selector(data) : data;

        dispatch({
          type: 'SUCCESS',
          payload: { data: handledData, total: data.total, ...options },
        });
      } catch ({ message }) {
        dispatch({ type: 'FAILURE', payload: message });
      }
    };

    fetchData();
  }, [options]);

  const getData = customParams => setOptions({ ...options, ...customParams });

  return [state, getData, dispatch];
}
